var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.6;}.cls-2{stroke:#000;stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "K18nXL.tif",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    className: "cls-2",
    d: "M21.06,14v-.84a1,1,0,0,1,1-1h.12a1,1,0,0,1,.82.92c0,.31,0,.62,0,.95h4.41a1,1,0,0,1,1,1V26.75a1,1,0,0,1-.95,1h-.08c-5,0-9.9,0-14.86,0a1.09,1.09,0,0,1-1.05-1.05q0-5.83,0-11.65A1.08,1.08,0,0,1,12.59,14c1.24,0,2.48,0,3.72,0h.22c0-.28,0-.56,0-.83a1,1,0,0,1,1-1h0a1.05,1.05,0,0,1,.94.93V14Zm-4.52.63h-4c-.28,0-.37.1-.37.39V26.79c0,.3.09.39.39.39H27.43c.35,0,.43-.08.43-.43V15.05c0-.33-.09-.41-.41-.41H23V15a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-.33H18.5c-.05.65-.06.7-.19.88a1,1,0,0,1-.77.41.94.94,0,0,1-.66-.23,1.12,1.12,0,0,1-.34-1.06Zm1.35-.6v-.92c0-.25-.11-.36-.33-.36s-.42.08-.42.36V15c0,.26.1.35.37.35s.38-.1.38-.35v-.94Zm3.78,0v1c0,.24.11.33.38.33s.37-.1.37-.34V13.11a.3.3,0,0,0-.26-.34h-.08c-.3,0-.41.08-.41.33V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    className: "cls-2",
    d: "M17.55,22.08l1.66.84.57.29a1,1,0,0,1,.53.8,5.81,5.81,0,0,1,0,.59,1,1,0,0,1-1,.91H13.87a1,1,0,0,1-1-1c0-.15,0-.31,0-.47a1,1,0,0,1,.55-.88l2-1,.15-.08a6.25,6.25,0,0,1-.62-.64,2.41,2.41,0,0,1,.41-3.29,1.81,1.81,0,0,1,2.42.07A2.41,2.41,0,0,1,18,21.66a1.78,1.78,0,0,1-.35.32Zm-.94,2.83h2.72c.29,0,.37-.08.38-.37,0-.12,0-.24,0-.37a.43.43,0,0,0-.29-.47c-.85-.42-1.7-.86-2.55-1.3a.49.49,0,0,0-.47,0q-1.29.66-2.58,1.29a.44.44,0,0,0-.31.5,1.71,1.71,0,0,1,0,.32c0,.32.08.4.4.4ZM18.06,20a3.85,3.85,0,0,0-.08-.49,1.45,1.45,0,0,0-1.17-1.12,1.34,1.34,0,0,0-1.41.74,2,2,0,0,0,0,1.95,1.36,1.36,0,0,0,1.84.54,1.27,1.27,0,0,0,.53-.52,2.14,2.14,0,0,0,.27-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    className: "cls-2",
    d: "M21.37,18.7v-.58h5.42v.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    className: "cls-2",
    d: "M21.37,24.15v-.58h5.42v.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    className: "cls-2",
    d: "M21.37,26v-.58h5.42V26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    className: "cls-2",
    d: "M26.8,19.94v.58H21.37v-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    className: "cls-2",
    d: "M21.37,22.33v-.57h5.42v.57Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBookIcon);
export default __webpack_public_path__ + "static/media/AddressBookIcon.2d6b3a37a82acf0e891deb7bb6f86c52.svg";
export { ForwardRef as ReactComponent };